(function ClientImportReview($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('/Clients/importClientsReview', function onload()
		{
			var $template_field = $("#clientimportreview-template_name");

			// toggle disabled state on rows that are being ignored
			$('[id^="clientimportreview-fields"]').on('change', function _ignoreRow()
			{
				var $self = $(this),
				    $row  = $self.parents('li.table-row');

				if ($self.val() === 'ignore_field') {
					$row.addClass('disabled');
				} else {
					$row.removeClass('disabled');
				}
			});

			// toggle template text field state
			$("#clientimportreview-save_as_template").on('change', function _toggleTemplate() {
				$template_field.prop('disabled', !$template_field.prop('disabled'));
			});
		});
	});

}(jQuery, window.Adzuki || {}));
